export default Object.freeze([
  {text: '支出', type: '-'},
  {text: '收入', type: '+'}
]);